import { map } from 'lodash';

import { formatQueryRange } from '../utils/common';
import { createFilePreview } from '../utils/filePreview';
import { normalizeVehicleInsuranceInformation } from '../utils/insurancePolicies';
import { cleanQueryParams } from '../utils/queryParams';
import { handleApiCalls } from './axiosInstance';

export const uploadVehicleInsuranceFiles = async files => {
  const url = `${process.env.REACT_APP_HOST_API}vehicle-insurances/uploads`;
  const formData = new FormData();

  (Array.isArray(files) ? files : [files]).filter(Boolean).forEach(file => {
    formData.append('files', file);
  });

  const result = await handleApiCalls('post', url, formData, {
    'Content-Type': 'multipart/form-data',
  });

  return result.data?.data ?? result.data;
};

export const fetchSelectedVehicleInsurance = async userId => {
  const url = `${process.env.REACT_APP_HOST_API}user/${userId}/vehicle-insurances/selected`;
  const result = await handleApiCalls('get', url);
  return normalizeVehicleInsuranceInformation(result.data?.data ?? result.data);
};

export const fetchVehicleInsurances = async (userId, pageNumber, pageSize) => {
  const queryParams = cleanQueryParams({
    range: formatQueryRange(pageNumber, pageSize),
  });
  const url = `${process.env.REACT_APP_HOST_API}user/${userId}/vehicle-insurances?${queryParams}`;
  const result = await handleApiCalls('get', url);
  const payload = result.data?.data ?? result.data;

  return {
    ...payload,
    documents: map(payload?.documents || [], normalizeVehicleInsuranceInformation),
  };
};

export const selectVehicleInsurance = async (userId, vehicleInsuranceId) => {
  const url = `${process.env.REACT_APP_HOST_API}user/${userId}/vehicle-insurances/${vehicleInsuranceId}/select`;
  const result = await handleApiCalls('patch', url);
  return normalizeVehicleInsuranceInformation(result.data?.data ?? result.data);
};

const fetchVehicleInsuranceUploadedFileBlob = async (
  vehicleInsuranceId,
  uploadedFileId,
  filename,
) => {
  const url = `${process.env.REACT_APP_HOST_API}vehicle-insurances/${vehicleInsuranceId}/uploaded-files/${uploadedFileId}/download`;
  const result = await handleApiCalls('get', url, { responseType: 'blob' });
  const file =
    filename && typeof File === 'function'
      ? new File([result.data], filename, { type: result.data.type })
      : result.data;

  return file;
};

export const fetchVehicleInsuranceUploadedFile = async (
  vehicleInsuranceId,
  uploadedFileId,
  filename,
) => {
  const file = await fetchVehicleInsuranceUploadedFileBlob(
    vehicleInsuranceId,
    uploadedFileId,
    filename,
  );

  return URL.createObjectURL(file);
};

export const fetchVehicleInsuranceUploadedFilePreview = async (
  vehicleInsuranceId,
  uploadedFileId,
  filename,
) => {
  const file = await fetchVehicleInsuranceUploadedFileBlob(
    vehicleInsuranceId,
    uploadedFileId,
    filename,
  );
  return createFilePreview(file);
};
